import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UserManagedListComponent.css';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  List,
  FormControlLabel,
} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import UserManagedButtonAreaComponent from './UserManagedButtonAreaComponent';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  setSortItem, setSortOrder, setNowPage,
  setUserResultList, setModifyPopFlg, setResetUser, setResetUserList,
  setUpdateUserId, setUpdateUserName, setUpdateRoleList, setUpdateDate,
  searchUserList,
} from '../../actions/UserManagedAction';
import {
  USER_RESULTPAGING,
  SORT_ITEM, SORT_ORDER,
} from '../../../common/const';
import CustomCheckbox from '../common/CustomCheckbox';

class UserManagedListComponent extends Component {
  /**
   * ページ選択
   * @param {string} page
   */
  changePage = async (page) => {
    const {
      searchUserId,
      searchUserName,
      searchRole,
      sortOrder,
      sortItem,
      setSystemLodingFlgAct,
      setNowPageAct,
      setUserResultListAct,
      searchUserListAct,
    } = this.props;
    setNowPageAct(page);
    // 検索API呼出し
    // ユーザー情報検索APIを呼び出す。
    setSystemLodingFlgAct(true);
    const response = await searchUserListAct(
      searchUserId,
      searchUserName,
      searchRole,
      sortItem,
      sortOrder,
      page,
    );
    setSystemLodingFlgAct(false);
    setUserResultListAct(response);
  }

  /**
   * ソート処理
   * @param {string} sortItem ソート項目
   */
  sortUserList = async (item) => {
    const {
      searchUserId,
      searchUserName,
      searchRole,
      sortItem,
      sortOrder,
      setSortOrderAct,
      setSystemLodingFlgAct,
      setSortItemAct,
      setUserResultListAct,
      searchUserListAct,
      setNowPageAct,
    } = this.props;

    let order;
    // ソート項目がユーザーIDの場合
    if (item !== sortItem) {
      // ソート項目を以前と変更していたら順序を昇順に変える。
      setSortItemAct(SORT_ITEM.USER_ID);
      order = SORT_ORDER.ASC;
      setSortOrderAct(order);
    } else {
      // ソート項目を依然と同じにしていたら順序を反転させる。
      order = (sortOrder === SORT_ORDER.ASC) ? SORT_ORDER.DESC : SORT_ORDER.ASC;
      setSortOrderAct(order);
    }
    setSortItemAct(item);
    // ユーザー情報検索APIを呼び出す。
    setSystemLodingFlgAct(true);
    setNowPageAct(1);
    const response = await searchUserListAct(
      searchUserId,
      searchUserName,
      searchRole,
      item,
      order,
      1,
    );
    setSystemLodingFlgAct(false);
    setUserResultListAct(response);
  }

  /**
  * ユーザー情報変更画面の表示
  */
  popUserModify = async (userId) => {
    const {
      setModifyPopFlgAct,
      setUpdateUserIdAct,
      setUpdateUserNameAct,
      setUpdateRoleListAct,
      setUpdateDateAct,
      setSystemLodingFlgAct,
      searchUserListAct,
    } = this.props;
    setSystemLodingFlgAct(true);
    // ユーザー情報検索API実行
    const response = await searchUserListAct(
      userId,
      null,
      null,
      SORT_ITEM.USER_ID,
      SORT_ORDER.ASC,
      1,
    );
    setSystemLodingFlgAct(false);
    if (response) {
      setUpdateUserIdAct(userId);
      setUpdateUserNameAct(response.user_list[0].user_name);
      setUpdateRoleListAct(response.user_list[0].role_name_list);
      setUpdateDateAct(response.user_list[0].update_datetime);
      setModifyPopFlgAct(true);
    }
  }

  /**
   * パスワード初期化チェックボックス変更
   */
  onChangePasswordResetCheckBox = (userId, checked) => {
    const {
      resetUserList,
      setResetUserListAct,
    } = this.props;
    // 選択したユーザーID
    const selUserId = userId;
    // 選択したユーザーリスト編集用の変数を宣言
    let newResetUserList = [];
    if (!checked) {
      // 選択したユーザーIDをリストに追加
      newResetUserList.push(selUserId);
      // 他に選択済みのものがあればユーザーリストに追加
      if (resetUserList && resetUserList.length > 0) {
        newResetUserList = resetUserList.concat(newResetUserList);
      }
    } else {
      const delIndex = resetUserList.indexOf(selUserId);
      // 配列位置が取得できた場合、該当のユーザIDを削除
      if (delIndex >= 0) {
        newResetUserList = resetUserList.concat(newResetUserList);
        newResetUserList.splice(delIndex, 1);
      }
    }
    setResetUserListAct(newResetUserList);
  }

  render() {
    const {
      userResultList,
      nowPage,
      sortItem,
      sortOrder,
      resetUserList,
    } = this.props;
    // ページングの表示処理 ここから
    let pagingArea = null;
    // 全体件数が最大表示件数以下の場合、ページング表示処理を実施
    if (userResultList
      && userResultList.all_count) {
      const maxPageCount = userResultList.all_count === 0
        ? 1
        : Math.ceil(userResultList.all_count / USER_RESULTPAGING.PAGE_RECORD_COUNT);
      // 最後のページ数を算出
      const endPageCount = nowPage + USER_RESULTPAGING.AFTER_PAGE_COUNT < maxPageCount
        ? nowPage + USER_RESULTPAGING.AFTER_PAGE_COUNT
        : maxPageCount;
      // 最初のページ数を算出
      const startPageCount = nowPage - USER_RESULTPAGING.BEFORE_PAGE_COUNT > 1
        ? nowPage - USER_RESULTPAGING.BEFORE_PAGE_COUNT
        : 1;
      const pageList = [];
      if (startPageCount > 1) {
        pageList.push(<span key={1} className="space">...</span>);
      }
      for (let count = startPageCount; count <= endPageCount; count += 1) {
        pageList.push(
          <span
            key={count}
            className={[
              endPageCount === count ? 'last-page-link' : 'page-link',
              nowPage === count ? 'nowpage' : '',
            ].join(' ')}
            onClick={nowPage === count
              ? null
              : this.changePage.bind(this, count)}
          >
            {count}
          </span>,
        );
      }
      if (endPageCount < maxPageCount) {
        pageList.push(<span key={maxPageCount} className="space">...</span>);
      }
      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={nowPage}
          className="displayInline"
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === nowPage
                || (item.type === 'next' && nowPage === maxPageCount)
                || (item.type === 'previous' && nowPage === 1)
              }
              className={`${item.page === nowPage ? 'customPaginationItem' : ''}`}
            />
          )}
        />
      );
    }
    // ページングの表示処理 ここまで
    // 表示件数作成
    const dispCountStart = (nowPage - 1) * USER_RESULTPAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (userResultList
      && userResultList.result_count
      && userResultList.all_count)
      ? (nowPage - 1) * USER_RESULTPAGING.PAGE_RECORD_COUNT + Number(userResultList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (userResultList && userResultList.all_count)
      ? Number(userResultList.all_count).toLocaleString()
      : 0;

    // 表示用のユーザー情報設定
    const dispUserList = userResultList;
    let userCount = 0;
    if (userResultList && userResultList.user_list) {
      userResultList.user_list.map((resultset) => {
        let role = '';
        if (resultset && resultset.role_name_list) {
          resultset.role_name_list.map((roleset) => {
            role += `${roleset}\n`;
            return role;
          });
        }
        role = role.slice(0, -1);
        dispUserList.user_list[userCount].role_list = role;
        userCount += 1;
        return dispUserList;
      });
    }

    let sortUserId = '';
    if (userResultList && userResultList.result_count > 0) {
      if (sortItem === SORT_ITEM.USER_ID) {
        if (sortOrder === SORT_ORDER.ASC) {
          sortUserId = <ArrowDropUpIcon className="fontSizeIcon" />;
        } else {
          sortUserId = <ArrowDropDownIcon className="fontSizeIcon" />;
        }
      } else {
        sortUserId = '';
      }
    } else {
      sortUserId = '';
    }

    let sortUserName = '';
    if (userResultList && userResultList.result_count > 0) {
      if (sortItem === SORT_ITEM.USER_NAME) {
        if (sortOrder === SORT_ORDER.ASC) {
          sortUserName = <ArrowDropUpIcon className="fontSizeIcon" />;
        } else {
          sortUserName = <ArrowDropDownIcon className="fontSizeIcon" />;
        }
      } else {
        sortUserName = '';
      }
    } else {
      sortUserName = '';
    }

    return (
      <div className="userManagedList">
        <div className="content">
          <div className="headerfield">
            <div className="subTitle">検索結果</div>
            <UserManagedButtonAreaComponent />
          </div>
          <div className="resultCount">
            <div>
              <span>検索結果：</span>
              <span className="searchResult">{dispResultCount}</span>
              {` / ${allCount}件`}
            </div>
            <div className="summary-page">
              {pagingArea}
            </div>
          </div>
          <Box className="searchResultarea">
            <Box className="searchResultareaTableHead">
              <Table className="tableLayoutFixed">
                <TableHead>
                  <TableRow>
                    <TableCell className="checkBox">&nbsp;</TableCell>
                    <TableCell
                      className={userResultList && userResultList.result_count > 0 ? 'userID headersort' : 'userID'}
                      onClick={userResultList && userResultList.result_count > 0
                        ? () => this.sortUserList(SORT_ITEM.USER_ID) : null}
                    >
                      <List tabIndex="-1" className="header">
                        <div className="title">ユーザーID</div>
                        <div className="sort">
                          {sortUserId}
                        </div>
                      </List>
                    </TableCell>
                    <TableCell
                      className={userResultList && userResultList.result_count > 0 ? 'userName headersort' : 'userName'}
                      onClick={
                        userResultList && userResultList.result_count > 0
                          ? () => this.sortUserList(SORT_ITEM.USER_NAME)
                          : null
                      }
                    >
                      <List className="header">
                        <div className="title">ユーザー名</div>
                        <div className="sort">
                          {sortUserName}
                        </div>
                      </List>
                    </TableCell>
                    <TableCell className="role">
                      <List className="header">
                        <div className="title">権限</div>
                      </List>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box className="productsconditionTableBody">
              <Table className="tableLayoutFixed">
                <TableBody className="searchResultareaTableBody">
                  {dispUserList
                    && dispUserList.user_list
                    && dispUserList.user_list.map((resultset) => (
                      <TableRow
                        key={resultset.user_id}
                      >
                        <TableCell className="checkboxarea bodyCheckBox">
                          <FormControlLabel
                            control={
                              (
                                <CustomCheckbox
                                  size="small"
                                  checked={resetUserList.indexOf(resultset.user_id) > -1}
                                  className="checkBoxStyle"
                                  onClick={() => this.onChangePasswordResetCheckBox(
                                    resultset.user_id,
                                    (resetUserList
                                      && resetUserList.indexOf(resultset.user_id) >= 0),
                                  )}
                                />
                              )
                            }
                          />
                        </TableCell>
                        <TableCell className="bodyUserID">
                          <div
                            className="item"
                            onClick={this.popUserModify.bind(this, resultset.user_id)}
                          >
                            {resultset.user_id}
                          </div>
                        </TableCell>
                        <TableCell className="bodyUserName">
                          <div
                            className="item"
                            onClick={this.popUserModify.bind(this, resultset.user_id)}
                          >
                            {resultset.user_name}
                          </div>
                        </TableCell>
                        <TableCell className="roleData">
                          <div
                            className="item"
                            onClick={this.popUserModify.bind(this, resultset.user_id)}
                          >
                            {resultset.role_list.split('\n').length > 0
                              ? (
                                <>
                                  <span className="space1">
                                    {resultset.role_list.split('\n')[0]}
                                  </span>
                                  {resultset.role_list.split('\n').length > 1
                                    ? (
                                      <span className="space2">
                                        {`他${resultset.role_list.split('\n').length - 1}件`}
                                      </span>
                                    )
                                    : <span className="space2" />}
                                </>
                              )
                              : <></>}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    searchUserId: state.usermanaged.searchUserId,
    searchUserName: state.usermanaged.searchUserName,
    searchRole: state.usermanaged.searchRole,
    sortItem: state.usermanaged.sortItem,
    sortOrder: state.usermanaged.sortOrder,
    nowPage: state.usermanaged.nowPage,
    userResultList: state.usermanaged.userResultList,
    resetUserList: state.usermanaged.resetUserList,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setSortItemAct: (str) => dispatch(setSortItem(str)),
    setSortOrderAct: (str) => dispatch(setSortOrder(str)),
    setNowPageAct: (str) => dispatch(setNowPage(str)),
    setUserResultListAct: (obj) => dispatch(setUserResultList(obj)),
    setModifyPopFlgAct: (strarr) => dispatch(setModifyPopFlg(strarr)),
    setResetUserAct: (str) => dispatch(setResetUser(str)),
    setResetUserListAct: (strarr) => dispatch(setResetUserList(strarr)),
    setUpdateUserIdAct: (str) => dispatch(setUpdateUserId(str)),
    setUpdateUserNameAct: (str) => dispatch(setUpdateUserName(str)),
    setUpdateRoleListAct: (strarr) => dispatch(setUpdateRoleList(strarr)),
    setUpdateDateAct: (str) => dispatch(setUpdateDate(str)),
    searchUserListAct: (
      userId, userName, role, sortItem, sortOrder, pageNumber,
    ) => dispatch(searchUserList(
      userId, userName, role, sortItem, sortOrder, pageNumber,
    )),
  }),
)(UserManagedListComponent);
